import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, InputNumber } from 'antd';
import * as actionTypes from '../../redux/actions/master/actionTypes';
import {  updateTwoDCommission } from '../../redux/actions/master/updateMaster';

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 },
};

class Update2DCommissionModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onUpdate({
            id:this.props.master?.id,
            commission:values.twoDCommission
        },
            this.props.token);
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update TwoD Commission"
                key={this.props.master?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-2dc-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                {...layout}
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-2dc-form"
                    name="basic"
                    initialValues={{
                        twoDCommission:this.props.master?.twoDCommission,
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="twoDCommission"
                        label="Commission"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.master.update2dCommissionVisible,
    loading: state.master.loading,
    token: state.auth.token,
    error: state.master.error,
    message: state.master.message,
    master:state.master.one
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (obj, token) => dispatch(updateTwoDCommission(obj, token)),
    onClose: () => dispatch({
        type:actionTypes.TOGGLE_2D_COMMISSION_UPDATE
    }),
})

export default connect(mapStateToProps, mapDispatchToProps)(Update2DCommissionModal);